import { Box, Typography, useTheme } from '@mui/material';
import React from 'react'
import { GeoAltFill } from 'react-bootstrap-icons';

function MostActiveSite({site}) {
    const theme = useTheme();
  return (
    <Box
      sx={{
        background: "white",
        padding: "24px",
        display: "flex",
        textAlign: "center",
        width: {xs: "100%", sm: "30%"},
        gap: "24px",
        borderRadius: "16px",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <GeoAltFill size={64} color={theme.palette.primary[500]} />
      <Box>
        <Typography variant="h4" fontWeight={700}>
          {site}
        </Typography>
        <Typography variant="body1" fontWeight={400} marginTop={1}>
          أكثر موقع مشاهدات
        </Typography>
      </Box>
    </Box>
  );
}

export default MostActiveSite